<priva-content-template>
    <priva-content-header [areaBottomTmp]="searchActivity" [hasOffset]="false">
        <priva-header
            [title]="pageName"
            [subtitle]="'GENERAL.TITLE.SELECT_ACTIVITY' | translate"
            data-test="select-activity-header"
        />
    </priva-content-header>

    <priva-content-section maxWidth="md" [isCentered]="true">
        @if (initializationFinished$ | async) {
            <app-activity-list
                [activities]="(filteredActivities$ | async) || []"
                (activitySelected)="onActivitySelected($event)"
                data-test="activity-list"
            />
        }
    </priva-content-section>
</priva-content-template>

<ng-template #searchActivity>
    <app-activity-filter
        [activities]="(activities$ | async) || []"
        [resetSearchTermsSignal]="resetSearchTermsSignal"
        (filteredActivitiesChanged)="onFilteredActivitiesChanged($event)"
    />
</ng-template>
